import { openDB } from 'idb';
export const runKeyStoreDbUpgrade = async (db, oldVersion, newVersion) => {
    switch (oldVersion) {
        case 0:
            if (newVersion != null && newVersion >= 1) {
                db.createObjectStore('keyPairs');
                db.createObjectStore('keys');
            }
            break;
        default:
            throw new Error(`Invalid db version ${oldVersion}`);
    }
};
const defaultDbLoader = async () => {
    return openDB('CapacitorKeyManager', 1, {
        async upgrade(db, oldVersion, newVersion) {
            await runKeyStoreDbUpgrade(db, oldVersion, newVersion);
        }
    });
};
export class IdbKeyStore {
    constructor({ dbLoader = defaultDbLoader } = {}) {
        this.dbLoader = dbLoader;
        this._db = null;
    }
    get db() {
        var _a;
        return (_a = this._db) !== null && _a !== void 0 ? _a : (this._db = this.dbLoader());
    }
    async getCryptoKey(alias) {
        var _a;
        const db = await this.db;
        return (_a = (await db.get('keys', alias))) !== null && _a !== void 0 ? _a : null;
    }
    async getCryptoKeyPair(alias) {
        var _a;
        const db = await this.db;
        return (_a = (await db.get('keyPairs', alias))) !== null && _a !== void 0 ? _a : null;
    }
    async putCryptoKeyPair(alias, keyPair) {
        const db = await this.db;
        await db.put('keyPairs', keyPair, alias);
    }
    async putCryptoKey(alias, key) {
        const db = await this.db;
        await db.put('keys', key, alias);
    }
    async deleteCryptoKeyPair(alias) {
        const db = await this.db;
        await db.delete('keyPairs', alias);
    }
    async deleteCryptoKey(alias) {
        const db = await this.db;
        await db.delete('keys', alias);
    }
}
//# sourceMappingURL=idb-key-store.js.map